// extracted by mini-css-extract-plugin
export default {"ctn":"MalwareConfiguration_ctn_g3Obw","table":"MalwareConfiguration_table_Tnyes","familyName":"MalwareConfiguration_familyName_Ldd65","noData":"MalwareConfiguration_noData_kQ3Zq"};